import { Injectable } from '@angular/core';
import { CVApiService } from 'src/app/reusables/services/cv-api.service';
import { ModuleManagerExportFormat } from 'src/shared/models/module-manager/module-manager-options.model';
import { MyRankingCollection } from './my-ranking.model';

@Injectable({
    providedIn: 'root'
})
export class MyRankingService {

    constructor(
        private cvApiService: CVApiService,
    ) { }

    async loadData(moduleKey: string, isAutoRefresh: boolean = false, isFirstLoad: boolean = false): Promise<MyRankingCollection> {
        let renderEndpoint: string;
        try {
            renderEndpoint = await this.cvApiService.getModuleRenderEndPoint(moduleKey);
        } catch (error) {
            console.error('Failed getting module render endpoint');
            throw error;
        }

        try {
            const url = `/api/v2/dashboards/modules/my-ranking/${moduleKey}?isAutoRefresh=${isAutoRefresh}&isFirstLoad=${isFirstLoad}`;
            const response = await this.cvApiService.get<MyRankingCollection>(url, renderEndpoint);
            if (response.status_code >= 200 && response.status_code < 300)
                return response.data;
            else throw response;
        } catch (error) {
            console.error('Failed getting data for My Ranking widget');
            throw error;
        }
    }

    async getExport(moduleKey: string, format: ModuleManagerExportFormat, isCXOne: boolean) {
        let renderEndpoint: string;
        try {
            renderEndpoint = await this.cvApiService.getModuleRenderEndPoint(moduleKey);
        } catch (error) {
            console.error('Failed getting widget render wndpoint');
        }

        try {
            const url = `/api/v2/dashboards/modules/my-ranking/${moduleKey}/export`;
            const options = `?format=${format}&isCXOne=${isCXOne}`;
            const response = await this.cvApiService.get<string>(url, renderEndpoint);
            if (response.status_code >= 200 && response.status_code < 300)
                return response;
            else
                throw response
        } catch (error) {
            console.error('Failed getting data to export My Ranking widget');
        }
    }
}
